/**
 * Created by OLD on 06/08/2015.
 */
define('thankYouMain',[
  'module',
  'logger',
  'thankYouMainRouter'
], function(
  module,
  Logger
) {
	'use strict';
	
  var ThankYou = {
    start: function() {
      Logger.log(module, 'starting ThankYouModule');
    },

    stop: function() {
      Logger.log(module, 'stopping ThankYouModule');
    }
  };

  module.exports = ThankYou;
});
